import { authFetch } from '../AuthFetch';
// import { createAction } from 'redux-actions';

export const forwardToFindRefinableMCases = () => (
  (dispatch) => {
    let url = '/maintenance/mcases/status';
    let request = { criteriaStatus: ['CHECKED', 'MODIFYING'] };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: "FIND_REFINABLE_MCASES",
        payload: json
      });
    });
  }
);

export const forwardToRefineMaintenanceCase = (casePk, operator) => (

  (dispatch) => {
    let url = '/maintenance/mcases/refine/' + casePk;
    let request = {
      casePk: casePk,
      kickoff: operator
    };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: "FIND_REFINABLE_MCASES",
        payload: json
      });
    });
  }
);

export const forwardToFindCard = (cardPk) => (

  (dispatch) => {
    let url = '/maintenance/cards/i' + cardPk;
    let request = { cardId: cardPk };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: "FIND_M_CARD",
        payload: json
      });
    });
  }
);

export const forwardToHideAppendDetailModal = () => (
  (dispatch) => {
    dispatch({
      type: "HIDE_APPEND_DETAIL_MODAL",
      payload: null
    });
  }
);

export const forwardToShowAppendDetailModal = (card, category) => (

  (dispatch) => {
    let payload = {
      card: card,
      category: category
    }
    dispatch({
      type: "SHOW_APPEND_DETAIL_MODAL",
      payload: payload
    });
  }
);

export const forwardToAssignAppendSet = (checkSet) => (
  (dispatch) => {
    let payload = {
      checkSet: checkSet,
    }
    dispatch({
      type: "ASSIGN_APPEND_SET",
      payload: payload
    });
  }
);

export const forwardToAssignAppendItem = (checkItem) => (
  (dispatch) => {
    let payload = {
      checkItem: checkItem
    }
    dispatch({
      type: "ASSIGN_APPEND_ITEM",
      payload: payload
    });
  }
);

export const forwardToAssignAppendNote = (note) => (
  (dispatch) => {
    let payload = {
      note: note
    }
    dispatch({
      type: "ASSIGN_APPEND_NOTE",
      payload: payload
    });
  }
);

export const forwardToRefineCardAsDiscardClothes = (cardPk, discard) => (

  (dispatch) => {
    let url = '/maintenance/cards/i' + cardPk + '/details/discard/c';
    let request = {
      cardId: cardPk,
      discardClothes: discard
    };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: "FIND_REFINABLE_DETAILS",
        payload: json
      });
    });
  }
);

export const forwardToRefineCardAsDiscardPant = (cardPk, discard) => (

  (dispatch) => {
    let url = '/maintenance/cards/i' + cardPk + '/details/discard/p';
    let request = {
      cardId: cardPk,
      discardPant: discard
    };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: "FIND_REFINABLE_DETAILS",
        payload: json
      });
    });
  }
);

export const forwardToFindCardDetails = (cardPk) => (

  (dispatch) => {
    let url = '/maintenance/cards/i' + cardPk + '/details';
    let request = { cardId: cardPk };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: "FIND_REFINABLE_DETAILS",
        payload: json
      });
    });
  }
);

export const forwardToDeleteDetail = (detailPk, cardPk) => (

  (dispatch) => {
    let url = '/maintenance/cards/i' + cardPk + '/details/i' + detailPk + '/del';
    let request = {
      cardId: cardPk,
      detailId: detailPk
    };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: "FIND_REFINABLE_DETAILS",
        payload: json
      });
    });
  }
);

export const forwardToMarkDetailAs = (asStatus, detailPk, cardPk, remover) => (

  (dispatch) => {
    let url = '/maintenance/cards/i' + cardPk + '/details/i' + detailPk + '/refine';
    let request = {
      cardId: cardPk,
      detailId: detailPk,
      refineStatus: asStatus,
      remover: remover
    };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: "FIND_REFINABLE_DETAILS",
        payload: json
      });
    });
  }
);

export const forwardToAppendMaintenanceDetail = (editing) => (
  (dispatch) => {
    let maintenanceDetail = {
      maintenanceCardId: editing.cardPk,
      categoryId: editing.categoryPk,
      setId: editing.setPk,
      itemId: editing.itemPk,
      note: editing.note,
      epc: editing.epc,
      refineStatus: "APPEND",
      status: "CREATED",
      creator: editing.creator
    };
    let url = '/maintenance/details/append';
    authFetch('POST', url, JSON.stringify(maintenanceDetail), (json) => {
      dispatch({
        type: 'FIND_REFINABLE_DETAILS',
        payload: json
      });
    });

    dispatch({
      type: "HIDE_APPEND_DETAIL_MODAL",
      payload: null
    });

    dispatch({
      type: 'SHOW_GLOBAL_ALERT',
      payload: '追加維修項目完成'
    });
  }
);

export const forwardToAssignModifyingMCaseTarget = (mCase) => (

  (dispatch) => {
    dispatch({
      type: "ASSIGN_MODIFYING_MCASE_TARGET",
      payload: mCase
    });
  }
);

export const forwardToAssignModifyingMCardTarget = (cardPk) => (

  (dispatch) => {
    dispatch({
      type: "ASSIGN_MODIFYING_MCARD_TARGET",
      payload: cardPk
    });
  }
);

export const forwardToSortRefinableMaintenanceCards = (cards, order) => {
  let asc = order.get('asc') == undefined ? true : order.get('asc');
  let by = order.get('by');
  let clone = [];
  cards.map((item, index) => {
    clone.push(item);
  });

  switch (by) {
    case "code":
      clone.sort((a, b) => {
        let comparison = asc ? (a.code < b.code) : (a.code > b.code);
        return comparison ? 1 : -1;
      });
      break;
    case "status":
      clone.sort((a, b) => {
        let comparison = asc ? (a.status < b.status) : (a.status > b.status);
        return comparison ? 1 : -1;
      });
      break;
    case "owner":
      clone.sort((a, b) => {
        let comparison = asc ? (a.owner < b.owner) : (a.owner > b.owner);
        return comparison ? 1 : -1;
      });
      break;
    case "unit":
      clone.sort((a, b) => {
        let comparison = asc ? (a.unit < b.unit) : (a.unit > b.unit);
        return comparison ? 1 : -1;
      });
      break;
  }

  let ret = (dispatch) => {
    dispatch(
      {
        type: 'SORT_REFINABLE_CARDS_BY_FIELD',
        payload: { cards: clone, order: order },
      }
    )
  }

  return ret;
};



// WEBPACK FOOTER //
// ./src/actions/maintenanceRefineAction.js